import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventCategoryIds = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['categoryIds'] => getEvent(eventKey)(store).categoryIds;
